<app-filter-header title="Filtrar torns" i18n-title  (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row">
    <app-filter-text-edit id="grua-torns-filter-descripcio" class="col-sm-9" i18n-label label="Desripció" [(value)]="filter.descripcion" contains></app-filter-text-edit>
    <!--<app-form-text-edit class="col-sm-3" type="time" i18n-label label="Hora inici" [(value)]="filter.hora_inicio" ></app-form-text-edit>
    <app-form-text-edit class="col-sm-3" type="time" i18n-label label="Hora fi" [(value)]="filter.hora_fin" ></app-form-text-edit>-->
  </div>
  
</div>
